'use client';
import { useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';
import { ReactNode, createContext } from 'react';
import type { StorefrontCategory } from '@/api/menu-list/storefront-menu-snapshot.types';
import { isAvailableNow } from '@/entities/venue/lib/useTimeAvailability';
import { QueryApi } from '@/features/query/api';
import { localeToLang } from '@/shared/i18n/localeToLang';

export const CategoriesContext = createContext<{ data: StorefrontCategory[] }>({ data: [] });

type Props = {
    children?: ReactNode;
};

export const CategoriesProvider = ({ children }: Props) => {
    const locale = useLocale();
    const menuListsQuery = useQuery(QueryApi.MenuList.queries.MenuLists);

    const categories =
        menuListsQuery.data?.menuLists
            .filter((menuList) => isAvailableNow(menuList.timeAvailability ?? []))
            .flatMap((menuList) =>
                [...menuList.categories].sort((a, b) => (a.sortIndex ?? 0) - (b.sortIndex ?? 0)),
            )
            .filter((category) => !!category.name[localeToLang(locale)]) ?? [];

    return <CategoriesContext.Provider value={{ data: categories }}>{children}</CategoriesContext.Provider>;
};
